module.exports = __webpack_public_path__ + "static/img/tab1-active.bd4c9131.jpg";